import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const loginPlaceId = localStorage.getItem("placeId");

export const generateCustomerDetailsExcel = async (data) => {
  if (!Array.isArray(data)) {
    console.error("Invalid data for Excel generation:", data);
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Customer Details");

  const depositProductSet = new Set();
  const loanProductSet = new Set();

  data.forEach((customer) => {
    if (customer.depositProducts) {
      Object.keys(customer.depositProducts).forEach((prod) => depositProductSet.add(prod));
    }
    if (customer.loanProducts) {
      Object.keys(customer.loanProducts).forEach((prod) => loanProductSet.add(prod));
    }
  });

  const depositProducts = Array.from(depositProductSet);
  const loanProducts = Array.from(loanProductSet);

  const staticHeaders = ["Customer No", "Full Name", "NIC", "Mobile", "Address"];
  const depositHeaders = depositProducts.map((prod) => `Deposit - ${prod}`);
  const loanHeaders = loanProducts.map((prod) => `Loan - ${prod}`);


  const headers = [
    ...staticHeaders,
    ...depositHeaders,
    "Total Deposits",
    ...loanHeaders,
    "Total Loans",
  ];

  worksheet.addRow(headers);

  data.forEach((customer) => {
    const row = [
      customer.cusNo,
      customer.fullName,
      customer.nicNo,
      customer.mobile,
      customer.address || "",
    ];

    let depositCount = 0;
    depositProducts.forEach((prod) => {
      const val = customer.depositProducts?.[prod] ?? "";
      if (val !== "" && val !== 0) depositCount++;
      row.push(val);
    });

    row.push(depositCount);

    let loanCount = 0;
    loanProducts.forEach((prod) => {
      const val = customer.loanProducts?.[prod] ?? "";
      if (val !== "" && val !== 0) loanCount++;
      row.push(val);
    });

    row.push(loanCount);

    const newRow = worksheet.addRow(row);

  
    if (newRow.number % 2 === 0) {
      newRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9D9D9" },
        };
      });
    }
  });

  // Auto column width
  worksheet.columns.forEach((col, index) => {
    let maxLength = 0;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, val.length);
    });

    if (["Full Name", "Address"].includes(headers[index])) {
      col.width = Math.min(maxLength + 2, 50);
    } else {
      col.width = maxLength < 15 ? 15 : maxLength + 2;
    }
  });

  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: "middle", horizontal: "center" };

  if (loginPlaceId === "1") {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.protection = { locked: true };
      });
    });

    await worksheet.protect("readonly123", {
      selectLockedCells: true,
      selectUnlockedCells: true,
      formatCells: false,
      formatColumns: false,
      formatRows: false,
      insertColumns: false,
      insertRows: false,
      insertHyperlinks: false,
      deleteColumns: false,
      deleteRows: false,
    });
  } else {
  
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.protection = { locked: false };
      });
    });
  }

  worksheet.views = [{ state: "frozen", xSplit: 5, ySplit: 1 }]; // 5 because of new Address column

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "CustomerDetailsReport.xlsx");
};
